import { render } from "./livingRoomSpace.vue?vue&type=template&id=7fbcd2fc&scoped=true"
import script from "./livingRoomSpace.vue?vue&type=script&lang=js"
export * from "./livingRoomSpace.vue?vue&type=script&lang=js"

import "./livingRoomSpace.vue?vue&type=style&index=0&id=7fbcd2fc&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbcd2fc"]])

export default __exports__